@if (loaderIcon | async) {
    <app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Layout Parts</h5>
                <ejs-tooltip id='tooltipbtnNew'  target="#targetNew" position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                    <button id="targetNew"  class="btn btnAS" [userPermissionHandler]="createPermissionHandlerData"
                    data-bs-toggle="modal" data-bs-target="#layoutPartModal" (click)="clickNewPart()">New</button>
                </ejs-tooltip>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ejs-grid [dataSource]="partsList" [allowFiltering]="false" height="350" (rowSelected)="onPartsRowSelected($event)">
                        <e-columns>
                            <e-column field="PartDescription" headerText="Part Name">
                            </e-column>
                            <e-column headerText="Delete" width="100" textAlign="Center">
                                <ng-template #template let-data>
                                    <ejs-tooltip id='tooltipCellDelete'  target="#targetNew1" position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                                        <a id="targetNew1" (click)="deletePart(data)" [userPermissionHandler]="deletePermissionHandlerData">
                                            <img id="imgDeleteLP" src="./assets/images/delete.svg" class="img-fluid"/></a>
                                    </ejs-tooltip>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="layoutPartModal" #layoutPartModal data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">Layout Parts</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <div class="col-12 text-start mt-2">
                            <label class="form-label">Part Name</label>
                            <input type="text" class="form-control" maxlength="50" [(ngModel)]="modalPartDescription" (keyup)="descriptionName.next($event)" (paste)="descriptionName.next($event)">
                            @if(partDescriptionExists) {
                                <div class="alert alert-danger">
                                    <span> Part Name exists!</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btnAS" data-bs-dismiss="modal" [disabled]="partDescriptionExists || modalPartDescription.trim() == '' || (this.modalPartId != 0 && this.currentPartDescription == modalPartDescription)"
                    (click)="clickSaveLayoutPart()">Save</button>
                    <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>